<template>
  <!-- NOTE (TEMPLATE) to show the proposal review -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <Article role="referee" />
  </div>
</template>

<script>
const Article = () => import("../../components/Article");

export default {
  components: { Article } // NOTE (COMPONENT) component of proposal
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
